import { render, staticRenderFns } from "./undistributedWork.vue?vue&type=template&id=0452791a&scoped=true&"
import script from "./undistributedWork.vue?vue&type=script&lang=js&"
export * from "./undistributedWork.vue?vue&type=script&lang=js&"
import style0 from "./undistributedWork.vue?vue&type=style&index=0&id=0452791a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0452791a",
  null
  
)

export default component.exports